import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as AssetPageFeature from 'ecosystem-marketplace-core/constants/groupTags/AssetPageFeature';
import { useStorefrontRouteParamTranslations } from '../../../storefront/hooks/useStorefrontRouteParamTranslations';
import { useModuleCategories } from '../../../modules/hooks/useModuleCategories';
import { useOfferingType } from '../../../context/OfferingTypeContext';

function ThemesResultsHeaderTitle({
  routeParams,
  searchTerm,
  title
}) {
  const {
    businessType,
    pageType,
    pageFeature
  } = routeParams;
  const {
    businessType: businessTypeText,
    pageType: pageTypeText,
    pageFeature: pageFeatureText
  } = useStorefrontRouteParamTranslations(routeParams, 'title');

  if (searchTerm) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.storefront.header.search.results"
    });
  }

  if (title) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: title
    });
  }

  if (businessType && pageType) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.resultsHeader.title.businessTypePageType",
      options: {
        businessType: businessTypeText,
        pageType: pageTypeText
      }
    });
  }

  if (businessType && pageFeature) {
    switch (pageFeature) {
      case AssetPageFeature.PARALLAX:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.businessTypePageFeature.PARALLAX",
          options: {
            businessType: businessTypeText
          }
        });

      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.businessTypePageFeature.defaultTitle",
          options: {
            businessType: businessTypeText,
            pageFeature: pageFeatureText
          }
        });
    }
  }

  if (pageType && pageFeature) {
    switch (pageFeature) {
      case AssetPageFeature.PARALLAX:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.pageTypePageFeature.PARALLAX",
          options: {
            pageType: pageTypeText
          }
        });

      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.pageTypePageFeature.defaultTitle",
          options: {
            pageType: pageTypeText,
            pageFeature: pageFeatureText
          }
        });
    }
  }

  if (businessType) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.resultsHeader.title.businessType",
      options: {
        businessType: businessTypeText
      }
    });
  }

  if (pageType) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.resultsHeader.title.pageType",
      options: {
        pageType: pageTypeText
      }
    });
  }

  if (pageFeature) {
    switch (pageFeature) {
      case AssetPageFeature.PARALLAX:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.pageFeature.PARALLAX"
        });

      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.resultsHeader.title.pageFeature.defaultTitle",
          options: {
            pageFeature: pageFeatureText
          }
        });
    }
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.themes.resultsHeader.title.default"
  });
}

function ModulesResultsHeaderTitle({
  routeParams,
  searchTerm,
  title
}) {
  const {
    category
  } = routeParams;
  const {
    getCategoryDisplayName
  } = useModuleCategories();

  if (searchTerm) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.storefront.header.search.results"
    });
  } else if (title) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: title
    });
  } else if (category) {
    try {
      const displayName = getCategoryDisplayName(category);
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.modules.resultsHeader.title.category",
        options: {
          category: displayName
        }
      });
    } catch (_unused) {
      /* do nothing */
    }
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.modules.resultsHeader.title.default"
  });
}

export function AssetResultsHeaderTitle(props) {
  const offeringType = useOfferingType();

  if (offeringType === 'THEME') {
    return /*#__PURE__*/_jsx(ThemesResultsHeaderTitle, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx(ModulesResultsHeaderTitle, Object.assign({}, props));
  }
}